import React from 'react';
import PropTypes from 'prop-types';
import Link from '~/components/I18nLink';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';
import themeVariables from '~/shared/themeVariables';

@withI18next()
class TagSuggestion extends React.PureComponent {
  render() {
    const { tags, t } = this.props;

    return (
      <div className="tag-suggestion">
        {tags.map((item, index) => (
          <Link
            href={`${Config.getDetailTagLinkByServiceType()}/${item}`}
            key={index}
          >
            <a className="tag-suggestion-item">
              {index === 0 ? <span style={{ padding: '0 4px' }}>|</span> : ''}{' '}
              {item}
              <span style={{ padding: '0 4px' }}>|</span>
            </a>
          </Link>
        ))}
        <style jsx>
          {`
            .tag-suggestion {
              background-color: rgba(10, 10, 10, 0.48);
              padding: 10px;
              border-radius: 2px;
              margin-left: 100px;
              margin-right: 100px;
              text-align: center;
            }
            .tag-suggestion a.tag-suggestion-item {
              color: #ffffff;
            }
            @media only screen and (max-width: ${themeVariables.breakpoints
                .mobile.maxWidth}px) {
              .tag-suggestion {
                height: 128px;
                overflow: hidden;
                margin: 0 30px;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

TagSuggestion.propTypes = {
  tags: PropTypes.array,
};

TagSuggestion.defaultProps = {
  tags: [],
};

export default TagSuggestion;
